"use client";

import { Button, cn } from "./ui";

export type StyleCategory = "commercial" | "personal";

export function StyleCategoryPicker({ value, onChange, className }: {
  value: StyleCategory;
  onChange: (value: StyleCategory) => void;
  className?: string;
}) {
  return (
    <div className={cn("mb-4 flex flex-wrap gap-2", className)} role="group" aria-label="Video style category">
      {(["commercial", "personal"] as const).map((category) => (
        <Button key={category} type="button"
          variant={value === category ? "primary" : "secondary"}
          aria-pressed={value === category} onClick={() => onChange(category)}>
          {category === "commercial" ? "Business" : "Personal"}
        </Button>
      ))}
    </div>
  );
}

export function PersonalStylePreview({ showIntro = true }: { showIntro?: boolean }) {
  return (
    <div className="space-y-3">
      {showIntro && <p className="text-sm text-muted">Videos for your special moments. Personal creation workflows are coming soon.</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        {[
          { name: "Wedding", description: "Wedding invitations, love stories and celebration highlights." },
          { name: "Birthday", description: "Birthday wishes, photo memories and celebration videos." },
        ].map((style) => (
          <div key={style.name} className="rounded-xl border border-line bg-white/[0.04] p-5">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-sm font-semibold">{style.name}</h3>
              <span className="rounded-full bg-white/10 px-2 py-1 text-[11px] text-muted">Coming soon</span>
            </div>
            <p className="mt-2 text-xs leading-5 text-muted">{style.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
